import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IBlotterFilterPromiseLookupService } from "../IBlotterFilterPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class BlotterFilterPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.BlotterFilterImpl>
  implements IBlotterFilterPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getMyBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>>;
  abstract getMySystemBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>>;
  abstract deleteItemsByIds(ids: string[]): Promise<boolean>;
  abstract createFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean>;
  abstract updateFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean>;
}
